<template>
  <v-app :class="hasDialogOpened ? 'dialogOpened' : ''">
    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      aboslute
      app
      v-if="token && !isLandingPage"
      width="200"
    >
      <div class="menu__logo">
        <div class="menu__logo_inner pa-3">
          <router-link to="/dashboard">
            <img src="@/assets/cia_logo_color.svg"
                 alt="Centrum Innowacyjnej Archiwizacji">
          </router-link>
        </div>
      </div>
      <mainMenu/>
      <div v-if="details" class="logout pa-3" :class="logoutClass">
        <p v-if="!miniVariant">{{details.first_name}} {{details.last_name}}</p>
        <p><a class="primary--text" @click.prevent="logoutUser">Wyloguj</a></p>
      </div>
    </v-navigation-drawer>
    <v-toolbar
      color="primary"
      dark
      app
      :clipped-left="clipped"
      v-if="token && !isLandingPage"
      class="toolbar-cia"
    >
      <v-toolbar-side-icon @click.stop="toggleMenu"></v-toolbar-side-icon>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div class="mainContent">
      <v-content>
        <div class="mainContent__inner" :class="additionalContentClass">
          <errors />
          <router-view/>
          <snackBar/>
          <cookies v-if="!isLandingPage" />
          <CookiesLp v-if="isLandingPage" />
        </div>
      </v-content>
      <ue v-if="!isLandingPage" />
    </div>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import mainMenu from './components/common/mainMenu.vue';
import snackBar from './components/common/MainSnackbar.vue';
import errors from './components/common/Errors/Errors.vue';
import ue from './components/common/UE.vue';
import cookies from './components/common/cookies.vue';
import CookiesLp from './components/LandingPage/cookies.vue';
import config from './config';

import { saveToken } from './service/axios';

export default {
  name: 'App',
  components: {
    mainMenu,
    snackBar,
    errors,
    ue,
    cookies,
    CookiesLp,
  },
  data() {
    return {
      clipped: true,
      drawer: false,
      miniVariant: false,
      scrollTop: 0,
    };
  },
  computed: {
    ...mapGetters('app', [
      'token',
    ]),
    ...mapGetters('user', [
      'details',
    ]),
    isLandingPage() {
      const disabledRoutes = [
        'LandingPage',
        'Regulations',
        'Donation',
        'PrivacyPolicy',
        'PageNotFound',
      ];
      return disabledRoutes.includes(this.$route.name);
    },
    additionalContentClass() {
      return `mainContent__inner--${this.$route.name}`;
    },
    isPublicRoute() {
      const currenRoute = this.$route.name;
      return config.publicRoutes.includes(currenRoute);
    },
    isMobile() {
      const breakpointName = this.$vuetify.breakpoint.name;
      return breakpointName === 'xs'
        || breakpointName === 'md'
        || breakpointName === 'sm';
    },
    hasDialogOpened() {
      return this.$store.state.clients.dialogVisibility
      || this.$store.state.subscriptions.dialogVisibility
      || this.$store.state.users.dialogVisibility
      || this.$store.state.files.dialogVisibility;
    },
    title() {
      return this.$vuetify.breakpoint.smAndDown ? 'CIA' : 'Centrum Innowacyjnej Archiwizacji';
    },
    logoutClass() {
      return this.$vuetify.breakpoint.smAndDown ? '' : 'logout--absolute';
    },
    bodyElement() {
      return document.getElementsByTagName('body')[0];
    },
    mainContent() {
      return document.getElementsByClassName('mainContent')[0];
    },
  },
  methods: {
    ...mapActions('app', [
      'logoutUser',
    ]),
    setBiggerFont() {
      const bodyClasses = document.body.classList;
      if (bodyClasses.contains('font-bigger')) {
        bodyClasses.remove('font-bigger');
      } else {
        bodyClasses.add('font-bigger');
      }
    },
    redirectToLogin() {
      if (!this.token && !this.isPublicRoute) {
        this.$router.push('/login');
      }
    },
    getToken() {
      if (this.token) {
        saveToken(this.token);
        this.$router.push('/dashboard');
      }
    },
    toggleMenu() {
      if (!this.isMobile) {
        this.miniVariant = !this.miniVariant;
        this.drawer = true;
      } else {
        this.miniVariant = false;
        this.drawer = !this.drawer;
      }
    },
    showMenu() {
      this.miniVariant = false;
      this.drawer = !this.isMobile;
    },
    addDialogClass() {
      this.scrollTop = window.scrollY;
      this.bodyElement.classList.add('noscroll');
      this.mainContent.style.transform = `translate(0, -${this.scrollTop}px)`;
    },
    removeDialogClass() {
      this.mainContent.style.transform = null;
      this.bodyElement.classList.remove('noscroll');
      window.scrollTo(0, this.scrollTop);
    },
  },
  mounted() {
    this.redirectToLogin();
    this.showMenu();
  },
  watch: {
    hasDialogOpened(val) {
      if (val) {
        this.addDialogClass();
      } else {
        this.removeDialogClass();
      }
    },
  },
  created() {
    this.getToken();
  },
};
</script>

<style lang="scss">
  @import "./scss/cia.scss";
</style>

